export class ProductReasonColletion {
    constructor() {
        this.reasons = [];
    }

    add(reason) {
        if(this.exist(reason.reasonId)){
            return;
        }
        this.reasons.push(reason);
        return this.reasons;
    }

    remove(reasonId) {
        const reasonWithIdIndex = this.reasons.findIndex((r) => r.reasonId === reasonId);

        if (reasonWithIdIndex > -1) {
            this.reasons.splice(reasonWithIdIndex, 1);
        }
        return this.reasons;
    }

    clear() {
        this.reasons = [];
        return this.reasons;
    }

    exist(reasonId) {
        const reasonWithIdIndex = this.reasons.findIndex((r) => r.reasonId === reasonId);
        return reasonWithIdIndex > -1;
    }

    hasReasons() {
        return this.reasons.length > 0;
    }

    getAll() {
        return this.reasons;
    }
}